import { Button, Form, Input, Spin } from 'antd'
import styles from './../../Login/Login.module.scss'
import { useNavigate } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {AppDispatch, RootState} from '../../../../app/store'
import {Message, roles, SUCCESS} from '../../../../configs/constant'
import notificationHandler from '../../../atoms/Notification'
import logo from '../../../../assets/images/logo.png'
import { authAdmin, setUsers } from './slice'
import jwt_decode from "jwt-decode";
import React, {useEffect} from 'react'
import LoadingPage from '../../../atoms/loading'
import { LoadingOutlined } from '@ant-design/icons'
import './../../../atoms/loading.scss'
import {LOCAL_STORAGE_TOKEN_ADMIN_CMS} from "../../../../configs/auth";

const LoginCms = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = React.useState(false);

  const antIcon = <LoadingOutlined style={{ fontSize: 70 ,position: 'fixed' }} spin />;
  const { auth }: any = useSelector((state: RootState) => state.authAdmin)

  const onFinish = (values: any) => {
    setLoading(true);
    if (values) {
      dispatch(authAdmin({ username: values.username, password: values.password })).unwrap().then((res: any) => {
          if (res.success === true) {
            notificationHandler('success', 'Đăng nhập tài khoản thành công!')
            dispatch(setUsers(jwt_decode(res.data.payload.token)))
            setLoading(false);
          } else {
            notificationHandler('error', res.response.data.data.msg_content)
            setLoading(false);
          }
        }).catch((error) => {
          notificationHandler('error', error.response.data.data.msg_content);
          setLoading(false);
        })
    }
  }
  const onFinishFailed = (errorInfo: any) => {

  }

  return (
   <>
    <div className={styles.login_page}>
    <div>
    <Spin indicator={antIcon} spinning={loading} />
      <div className={styles.login_box}>
        <Form
          name={styles.login_form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <img src={logo} alt="Logo" className='mx-auto' />
          <p className='text-center text-[18px]'>Hệ thống quản trị bếp ăn Viettel</p>
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Nhập tài khoản!' }]}
          >
            <Input placeholder="Tài khoản " onBlur={(e) => e.target.value = e.target.value.trim()} maxLength={200} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Nhập mật khẩu!' }]}
          >
            <Input.Password placeholder="Mật khẩu"onBlur={(e) => e.target.value = e.target.value.trim()} maxLength={50} />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              className="login-form-button text-white p-[5px_20px] bg-primary hover:border-primary hover:text-primary mx-auto mt-3 w-full"
            >
              Đăng Nhập
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
    </div>
   </>
  )
}

export default LoginCms
